import {
    firebaseAuth,
    firebaseFire as Libfirebase,
    firebaseStorage
} from '../helpers/firebase-config.js';


const urlFunctions = "https://us-central1-globalbrain-ba498.cloudfunctions.net/pdf/";
// const urlFunctions = "http://localhost:5001/globalbrain-ba498/us-central1/pdf/";

// export async function sendEmailSolicExame(id_paciente, id_solic) {
//     return new Promise(function (resolve, reject) {
//         var xhr = new XMLHttpRequest()
//         xhr.addEventListener('load', () => {
//             if (xhr.responseText === 'OK') {
//                 resolve('E-mail enviado para o paciente!');
//             } else {
//                 reject('Erro ao enviar e-mail para o paciente!');
//             }
//         })
//         xhr.open('GET', urlFunctions + "solicitacao_exame?result=email&solicitacao_id=" +
//             id_solic + "&paciente_id=" + id_paciente);
//         xhr.send();
//     });
// }
export async function sendEmailWhats(id_paciente, id_solic, tipo, dados, tipo_exame) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest()
        xhr.addEventListener('load', () => {
            let tipoDesc = (tipo === 'E') ? 'E-mail' : 'Whatsapp'
            if (xhr.responseText === 'OK') {
                resolve(tipoDesc + ' enviado para o contato informado!');
            } else {
                console.log("ERROR AO ENVIAR EMAIL ", xhr.response, xhr.responseText)

                reject('Erro ao enviar ' + tipoDesc + ' para o contato informado!');
            }
        })
        xhr.open('GET', urlFunctions + tipo_exame + "?result=emailwhats&id=" +
            id_solic + "&paciente_id=" + id_paciente + "&tipo=" + tipo + "&dados=" + dados);

        console.log(urlFunctions + tipo_exame + "?result=emailwhats&id=" +
            id_solic + "&paciente_id=" + id_paciente + "&tipo=" + tipo + "&dados=" + dados);
        xhr.send();
    });
}

export async function sendEmailSolicExame(id_paciente, id_solic, tipo, dados) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest()
        xhr.addEventListener('load', () => {
            let tipoDesc = (tipo === 'E') ? 'E-mail' : 'Whatsapp'
            if (xhr.responseText === 'OK') {
                resolve(tipoDesc + ' enviado para o contato informado!');
            } else {
                console.log("ERROR AO ENVIAR EMAIL ", xhr.response, xhr.responseText)

                reject('Erro ao enviar ' + tipoDesc + ' para o contato informado!');
            }
        })
        xhr.open('GET', urlFunctions + "solicitacao_exame?result=emailwhats&solicitacao_id=" +
            id_solic + "&paciente_id=" + id_paciente + "&tipo=" + tipo + "&dados=" + dados);
        xhr.send();
    });
}

export async function openSolicExame(id_paciente, id_solic) {
    window.open(urlFunctions + "solicitacao_exame?result=pdf&id=" +
        id_solic + "&paciente_id=" + id_paciente);
}

export async function sendEmailReceita(id_paciente, id_receita, tipo) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.addEventListener('load', () => {
            if (xhr.responseText === 'OK') {
                resolve('E-mail enviado para o paciente!');
            } else {
                console.log("ERROR AO ENVIAR EMAIL ", xhr.response, xhr.responseText)

                reject('Erro ao enviar e-mail para o paciente!');
            }
        })
        xhr.open('GET', urlFunctions + (tipo === "Comum" ? "receituario_info" : "receituario_especial") + "?result=email&id=" +
            id_receita + "&paciente_id=" + id_paciente);
        xhr.send();
    });
}
export async function openReceita(id_paciente, id_receita, tipo) {
    window.open(urlFunctions + (tipo === "Comum" ? "receituario_info" : "receituario_especial") + "?result=pdf&id=" +
        id_receita + "&paciente_id=" + id_paciente);
}

export async function sendEmailReceituario(id_paciente, id_receituario) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.addEventListener('load', () => {
            if (xhr.responseText === 'OK') {
                resolve('E-mail enviado para o paciente!');
            } else {
                console.log("ERROR AO ENVIAR EMAIL ", xhr.response, xhr.responseText)

                reject('Erro ao enviar e-mail para o paciente!');
            }
        })
        xhr.open('GET', urlFunctions + "receituario_exame?result=email&id=" +
            id_receituario + "&paciente_id=" + id_paciente);
        xhr.send();
    });
}

export async function openReceituario(id_paciente, id_receituario) {
    window.open(urlFunctions + "receituario_exame?result=pdf&id=" +
        id_receituario + "&paciente_id=" + id_paciente);
}

export async function sendEmailAtestado(id_paciente, id_atestado) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.addEventListener('load', () => {
            if (xhr.responseText === 'OK') {
                resolve('E-mail enviado para o paciente!');
            } else {
                console.log("ERROR AO ENVIAR EMAIL ", xhr.response, xhr.responseText)
                reject('Erro ao enviar e-mail para o paciente!');
            }
        })
        xhr.open('GET', urlFunctions + "atestado?result=email&id=" +
            id_atestado + "&paciente_id=" + id_paciente);
        xhr.send();
    });
}
export async function openAtestado(id_paciente, id_atestado) {
    window.open(urlFunctions + "atestado?result=pdf&id=" +
        id_atestado + "&paciente_id=" + id_paciente);
}